import { ACTION_STATUS } from "../actionbar-detail.constant";
import { ButtonBase } from "./button.base";

export class DriversLicenseButtonModel extends ButtonBase {
    label: string = "Driver's license";
    action: string = ACTION_STATUS.driversLicense;
    matIconName: string = 'person_pin';
    colorClass: string = 'color-info-500';
}